(function ($) {
  $.fn.megaDropDown = function () {
    var elem = $(this),
      triggers = elem.find('.js-mega-dropdown__trigger'),
      panels = elem.find('.js-mega-dropdown__panel'),
      closeButtons = elem.find('.js-mega-dropdown__close'),
      settings = {
        activeClass: 'is-active',
        loadedClass: 'is-loaded',
        ajaxPlaceholderSelector: '.js-mega-dropdown__ajax-placeholder',
        ajaxUrl: '/ajax/',
        carouselDataAttribute: 'data-carousel',
      };

    var init = function () {
        // Bind click event to triggers
        triggers.off('click').on('click', function (evt) {
          evt.preventDefault();

          // Load the trigger and its related panel
          var trigger = $(this),
            panel = panels.filter(trigger.attr('href'));

          // If the trigger is already active, just close all
          if (trigger.hasClass(settings.activeClass)) {
            closeAll();
            return;
          }

          // Run the close all method with a callback
          closeAll(function () {
            // If there is a panel
            if (panel.any()) {
              // Add active classes to relevant elems
              trigger.addClass(settings.activeClass);
              panel.addClass(settings.activeClass);

              // If the panel has not loaded its content yet, run the method
              if (!panel.hasClass(settings.loadedClass)) {
                loadContent(panel);
              }
            }
          });
        });

        // Tie close all to close buttons
        closeButtons.off('click').on('click', function (evt) {
          evt.preventDefault();

          closeAll();
        });

        // Tie close all to escape key
        $.esc({
          callback: function (evt) {
            closeAll();
          },
        });
      },
      // Load content into the panel via ajax
      loadContent = function (panel) {
        if (panel.attr(settings.carouselDataAttribute)) {
          var url = settings.ajaxUrl;
          if (panel.attr(settings.carouselDataAttribute) === 'team') {
            url += 'carousels.aspx?type=team';
          } else {
            url += 'appointmentcarousel.aspx';
          }

          $.ajaxHtml(url, function (data, isSuccess) {
            if (isSuccess) {
              panel.addClass(settings.loadedClass);

              var placeholder = panel.find(settings.ajaxPlaceholderSelector);

              if (placeholder.any()) {
                placeholder.replaceWith(data);

                app.bind(panel);
              }
            }
          });
        }
      },
      // Handles all the close functionality
      closeAll = function (callback) {
        // Clean up active states and blur items
        triggers.trigger('blur').removeClass(settings.activeClass);
        panels.removeClass(settings.activeClass);

        // Run callback if set
        if (typeof callback == 'function') {
          callback();
        }
      };

    init();
    return this;
  };
})($);
